/** message topic filter */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'topic' })
export class TopicPipe implements PipeTransform {
    transform(items: any, filter: string): any {
        if (!items || !filter) {
            return items;
        }
        return items.filter(item => {
            if (item.topic) {
                return item.topic === filter;
            } else {
                return item;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/topic.pipe.ts